export default {
      id: "addСircle-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#addСircle-usage",
      toString: function () {
        return this.url;
      }
    }